import {
    type GetAllAccountDeletionRequestsResponseType,
    type GetAllAccountDeletionRequestsRequestType
} from "./type";
import {
    request
} from "../request";

const getAllAccountDeletionRequests = async (
    params: GetAllAccountDeletionRequestsRequestType
): Promise<GetAllAccountDeletionRequestsResponseType> => {
    const searchParams = new URLSearchParams();

    if(params.search) {
        searchParams.append("search", params.search);
    }

    if(params.page !== undefined) {
        searchParams.append("page", String(params.page));
    }

    const queryStr = searchParams.toString();
    const endpoint = queryStr ? `/request/getAllAccountDeletionRequests?${queryStr}` : "/request/getAllAccountDeletionRequests";

    return await request<GetAllAccountDeletionRequestsResponseType>(endpoint, {
        method: "GET"
    });
};
export default getAllAccountDeletionRequests;
